<app-scrollable-dialog headerKey="label.changeHistory">
  <app-history content [loaded]="loaded" [data]="records">
    <ng-template #major let-record="data">
      <ng-container *ngIf="!record.changes?.length"> {{ 'user.created' | locCap }} </ng-container>
      <div *ngFor="let change of transformChanges(record.changes)">
        <ng-container *ngIf="change.nested?.length">
          - {{ changeTitle(change) | locCap }}:
          <div *ngFor="let n of change.nested" class="padding-left-10">
            <ng-container *ngTemplateOutlet="history; context: { value: n }"></ng-container>
          </div>
        </ng-container>
        <div *ngIf="!change.nested?.length">
          <ng-container *ngTemplateOutlet="history; context: { value: change }"></ng-container>
        </div>
      </div>
    </ng-template>
    <ng-template #minor let-record="data">
      {{ record.date | lDate: 'dtLong' }} | {{ record.userName || ('label.system' | locCap) }}
    </ng-template>
  </app-history>
</app-scrollable-dialog>

<ng-template #history let-value="value">
  - {{ changeTitle(value) | locCap }}: <span [innerHTML]="changeValue(value)"></span>
</ng-template>
